export const HEADER_HEIGHT = 50;
export const APP_INSTALLER_HEIGHT = 40;
export const BOTTOM_NAVIGATION_HEIGHT = 70;

export const Z_INDEX = {
  DAILY_LOGIN_CONTAINER_WRAPPER: "!z-[9998]",
  DAILY_LOGIN_BACK_DROP: "!z-[9997]",
  PAGE_HEADER: "z-[10]",
  PROMOTION_EVENT_BADGES: "z-[8]",
  // Above AutoPromotionPopup's backdrop/container (5001/5002).
  VIP_BONUS_BADGE_MODAL: "z-[5003]",
  CASHBACK_MISSION_COMPLETE_CONTAINER_WRAPPER: "!z-[9]",
  CASHBACK_MISSION_COMPLETE_BACK_DROP: "!z-[8]",
};

export const REWARD_CHEST_OPEN_HEIGHT_CLASS = "h-[270px] min-h-[270px]";
export const REWARD_CHEST_CLOSED_HEIGHT_CLASS = "h-[225px] min-h-[225px]";

export const BALANCE_BADGE_TOP_ID = "balance-badge-top";

// Two ids: the Cashback page badge and the Auto Claim modal badge can be mounted at the same
// time, and getElementById would only ever find the first of a shared id.
export const VIP_BONUS_BADGE_ID = "vip-bonus-badge";
export const VIP_BONUS_BADGE_MODAL_ID = "vip-bonus-badge-modal";
export const ONBOARDING_DIALOG_CLASS_NAME = "onboarding-dialog";

export const APP_VERSION_FORMAT = "vYYMMDDHHmm";

export const FUNDING_PROFILE_INFO_TOP_BAR_ID = "funding-profile-info-top-bar";

export const TOAST_OFFSET = 24;
export const TOAST_CONTAINER_ID = "react-hot-toast-container";
export const ACTION_TOAST_DURATION_MS = 8000;
export const CLOSEABLE_TOAST_DURATION_MS = 8000;

// react-hot-toast hardcodes zIndex: 9999, same as some portaled dialogs (MegaShareFriendDialog,
// CSCompensationDialog, etc), so toasts fired from inside them render behind. This fixes that.
export const TOAST_Z_INDEX = 10002;

export const CASHBACK_TOAST_DURATION_MS = 3000;
export const INSTALL_NUDGE_DURATION_MS = 8000;
